package org.lennycodes.hldi.layouts
import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Main
import org.lennycodes.hldi.components.Footer
import org.lennycodes.hldi.components.Navbar

@Composable
fun MainLayout(content: @Composable () -> Unit) {
    Column(
        modifier = Modifier
            .fillMaxWidth()
            .minHeight(100.vh)
            .display(DisplayStyle.Flex)
            .flexDirection(FlexDirection.Column)
    ) {
        Navbar()
        Main(
            attrs = Modifier
                .fillMaxWidth()
                .flex(1)
                .padding(top = 80.px) // Account for sticky navbar
                .toAttrs()
        ) {
            content()
        }
        Footer()
    }
}